// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

const _map = {"s":"s","m":"m","l":"l"};

function sizeToJs(param) {
  return param;
}

function sizeFromJs(param) {
  return _map[param];
}

function Input(Props) {
  let className = Props.className;
  let valueOpt = Props.value;
  let placeholderOpt = Props.placeholder;
  let type_Opt = Props.type_;
  let disabledOpt = Props.disabled;
  let readOnlyOpt = Props.readOnly;
  let requiredOpt = Props.required;
  let isFocusedOpt = Props.isFocused;
  let darkModeOpt = Props.darkMode;
  let onKeyPress = Props.onKeyPress;
  let onChangeOpt = Props.onChange;
  let onFocusOpt = Props.onFocus;
  let onBlurOpt = Props.onBlur;
  const value = valueOpt !== undefined ? valueOpt : "";
  const placeholder = placeholderOpt !== undefined ? placeholderOpt : "";
  const type_ = type_Opt !== undefined ? type_Opt : "text";
  const disabled = disabledOpt !== undefined ? disabledOpt : false;
  const readOnly = readOnlyOpt !== undefined ? readOnlyOpt : false;
  const required = requiredOpt !== undefined ? requiredOpt : false;
  const isFocused = isFocusedOpt !== undefined ? isFocusedOpt : false;
  const darkMode = darkModeOpt !== undefined ? darkModeOpt : false;
  const onChange = onChangeOpt !== undefined ? onChangeOpt : (function (param) {
      
    });
  const onFocus = onFocusOpt !== undefined ? onFocusOpt : (function (param) {
      
    });
  const onBlur = onBlurOpt !== undefined ? onBlurOpt : (function (param) {
      
    });
  const className$1 = Cn.fromList({
    hd: Cn.on("text-white bg-black", darkMode),
    tl: {
      hd: Cn.take(className),
      tl: {
        hd: "text-sm box-border w-full",
        tl: /* [] */ 0
      }
    }
  });
  const inputRef = React.useRef(null);
  React.useEffect((function () {
    if (isFocused) {
      const __x = inputRef.current;
      Belt__Belt_Option.map((__x == null) ? undefined : Caml_option.some(__x), (function (el) {
        return el.focus();
      }));
    }
    
  }), [
    isFocused,
    inputRef
  ]);
  let tmp = {
    ref: inputRef,
    className: className$1,
    disabled: disabled,
    placeholder: placeholder,
    readOnly: readOnly,
    required: required,
    type: type_,
    value: value,
    onFocus: (function (param) {
      Curry._1(onFocus, undefined);
    }),
    onBlur: (function (param) {
      Curry._1(onBlur, undefined);
    }),
    onChange: (function (ev) {
      Curry._1(onChange, ev.target.value);
    })
  };
  if (onKeyPress !== undefined) {
    tmp.onKeyPress = Caml_option.valFromOption(onKeyPress);
  }
  return JsxRuntime.jsx("input", tmp);
}

const make = Input;

export {
  sizeToJs,
  sizeFromJs,
  make,
}
/* react Not a pure module */
